module.exports = __webpack_public_path__ + "static/img/walking-man-bluegrey.9abef22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/walking-man-bluegrey.svg
// module id = KHlh
// module chunks = 82